export default __webpack_public_path__ + "static/media/logo_bycoders_.e8adf476.svg";